import { createEnumParam } from 'use-query-params';

export const UpdateParam = createEnumParam([
    'any',
    '4-1729',
    '1729-9228',
    '9228-63099',
    '63099-120716',
    '120716-184402',
    '184402-418434',
    '418434-826013',
    '826013-1619692',
    '1619692-2808696',
    '2808696-11007009',
    '11007009-28355990',
    '28355990-97452273',
    '97452273-1000000000',
]);
